module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notification":{"notLoaded":"Cover letter not loaded!","notGenerated":"The report hasn\u0027t been generated yet!"}}}')
  delete Component.options._Ctor
}
